import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const LineHeightUnit = z.enum(["Pixels", "Rem", "Percent", "Raw"]);
export const LineHeightValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const LineHeightTokenData = tokenAliasOrValue(LineHeightValue);
